import { CategoryBaseInfo } from '@/api/types/categories.types';
import { Breadcrumb } from '@/components/Breadcrumbs/Breadcrumbs.types';

function handleParent(category: CategoryBaseInfo, breadcrumbs: Breadcrumb[]) {
  if (category.parent) {
    const link = `/${category.parent.path}`;
    breadcrumbs.unshift({ label: category.parent.name, link });

    handleParent(category.parent, breadcrumbs);
  }
}

export function buildBreadcrumbs(
  category?: CategoryBaseInfo | null
): Breadcrumb[] {
  if (!category) return [];

  const breadcrumbs = [];

  breadcrumbs.push({ label: category.name, link: `/${category.path}` });

  handleParent(category, breadcrumbs);

  return breadcrumbs;
}
